import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";
import { storeRequester } from "App";
import NewWishCard from "components/card/wish/NewWishCard";
import CheckCircleGroup from "components/inputs/checkBox/CheckCircleGroup";
import CheckCircle from "components/inputs/checkBox/CheckCircle";
import { CButton } from "@coreui/react";
import Dummy from "components/Dummy";
import NiceModal from "@ebay/nice-modal-react";
import { toast } from "react-toastify";




const WishCardRow = forwardRef((props, ref) => {
    const { data, index, callback: parentCallback, isMobile, onDelete } = props;
    const input = useRef();

    const handleAddToCart = () => {
        if (isMobile) {
            NiceModal.show("mobileAddCart", { product: data });
        } else {
            NiceModal.show("addCartCount", { product: data });
        }
    };

    const handleDelete = () => {
        if (onDelete) {
            onDelete();
        }
    };

    useEffect(() => {
        if (props.checkedIndex && props.checkedIndex.includes(props.index)) {
            input.current.setChecked(true);
        } else {
            input.current.setChecked(false);
        }
    }, [props.checkedIndex]);

    useImperativeHandle(ref, () => ({
        isChecked() {
            return input.current.isChecked();
        },
        setChecked(value) {
            input.current.setChecked(value);
        },
        isCheckedVaild() {
            return input.current.isChecked();
        }
    }));

    const handleCheck = (index, isChecked) => {
        if (parentCallback) {
            parentCallback(index, isChecked, data);
        }
    };

    return (
        <div style={{ width: '100%' }}>
            <HorizontalFlex gap={20} padding={"0 10px"} alignItems="center">
                <FlexChild width="40px" flexShrink={0}>
                    <CheckCircle
                        ref={input}
                        callback={handleCheck}
                        index={index}
                        checkedData={data}
                    />
                </FlexChild>
                <FlexChild style={{ width: '80%', minWidth: 0 }}>
                    <NewWishCard
                        data={data}
                        addCartButtonClick={handleAddToCart}
                        deleteButtonClick={handleDelete}
                    />
                </FlexChild>
            </HorizontalFlex>
        </div>
    );
});

function WishListLayout() {
    const { t } = useTranslation();
    const { isMobile } = useContext(BrowserDetectContext);
    const [interests, setInterests] = useState([]);
    const checkGroupRef = useRef();

    // 관심 목록 조회
    const fetchInterests = () => {
        storeRequester.getInterest(
            (response) => setInterests(response.interests)
        );
    };

    // 단일 삭제 처리
    const deleteInterest = async (id, showToast = true, refresh = true) => {  // refresh 파라미터 추가
        try {
            await storeRequester.delete(`/customers/me/interests/${id}`);
            // checkGroupRef.current.reset();
            if (showToast) {
                toast.success('상품이 관심목록에서 삭제되었습니다', {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
            if (refresh) {  // 단일 삭제일 때만 새로고침
                fetchInterests();
            }
        } catch (error) {
            if (showToast) {
                toast.error('삭제 중 오류가 발생했습니다', {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
            throw error;
        }
    };



    // 다중 삭제 처리
    const handleBulkDelete = async () => {
        const selectedIndexes = checkGroupRef.current.getCheckedIndex();
        // 선택된 개수 저장
        const deleteCount = selectedIndexes.length;

        if (deleteCount === 0) {
            toast.error('삭제할 상품을 선택해주세요', {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            return;
        }

        try {
            // 선택된 아이템의 ID들을 먼저 수집
            const idsToDelete = selectedIndexes.map(index => interests[index].id);
            
            // 삭제 요청 실행
            await Promise.all(
                idsToDelete.map(id => deleteInterest(id, false, false))
            );

            // 체크박스 초기화
            checkGroupRef.current.reset();
            // 목록 새로고침
            fetchInterests();
            // 저장해둔 개수로 메시지 표시
            toast.success(`${deleteCount}개의 상품이 관심목록에서 삭제되었습니다`, {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        } catch (error) {
            toast.error('선택한 상품 삭제 중 오류가 발생했습니다', {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        }
    };


    useEffect(() => {
        fetchInterests();
    }, []);


    const wishListHeader = [];

    return (
        <Container backgroundColor={"white"} maxWidth={1300}>
            <VerticalFlex>
                <FlexChild>
                    <Dummy height={isMobile ? 30 : 70} />
                    <HorizontalFlex justifyContent={"space-between"} gap={10}>
                        <FlexChild>
                            <P size={36} weight={'bold'}>관심 상품</P>
                        </FlexChild>
                        <FlexChild justifyContent={"flex-end"}>
                            <CButton onClick={handleBulkDelete}>선택 상품 삭제</CButton>
                        </FlexChild>
                    </HorizontalFlex>
                    <Dummy height={10} />
                </FlexChild>
                <FlexChild style={{ width: '100%' }}>
                    <CheckCircleGroup
                        ref={checkGroupRef}
                        // callback={handleBulkAction}
                        label="전체 선택"
                        gap={30}
                        labelWidth={100}
                        padding={10}
                        backgroundColor={"#f5f6fb"}
                        borderTop={"1px solid #ddd"}
                        borderBottom={"1px solid #ddd"}
                        header={!isMobile && wishListHeader}
                        headerGap={20}
                    >
                        {interests && interests?.map((item, index) => (
                            <WishCardRow
                                key={item.id}
                                index={index}
                                data={item.product}
                                isMobile={isMobile}
                                onDelete={() => deleteInterest(item.id)}
                            />
                        ))}
                    </CheckCircleGroup>
                    <Dummy height={30} />
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
}

export default WishListLayout;